(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name mealDetail.controller:MealDetailCtrl
   *
   * @description
   *
   */
  angular
    .module('mealDetail')
    .controller('MealDetailCtrl', MealDetailCtrl);

  function MealDetailCtrl($sce , RemoteService , MessageService, CommonLogicService ) {
    var vm = this;
    vm.ctrlName = 'MealDetailCtrl';
    vm.view = "MEAL_DETAIL";
    vm.model = {
      masterList: {
        canvasHeight: 0,
        canvasWidth: 0,
        tab: 1,
      },
      searchCriteria: {
        depatureDate: null,
        flightNumber: null
      },
      searchPanelToggle: false,
      mealData: {
        mealSummary: [],
        mealDetails: []
      },
      rptDesign: null,
      url : null,
      reportDataURL : null,
      searchParamMap : {}
    };

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
    };

    vm.tabClick = function (tabId) {
      vm.model.masterList.tab = tabId;
    };

    vm.generateMealReport = function () {
      if(vm.model.masterList.tab == 1 ) {
        vm.model.rptDesign = 'FlightMealSummary.rptdesign';
      }else if(vm.model.masterList.tab == 2 ) {
        vm.model.rptDesign = 'FlightMealDetails.rptdesign';
      }

      vm.model.url = CommonLogicService.getReportUrl(vm.model.rptDesign, getSearchParamMap());
      vm.model.reportDataURL = $sce.trustAsResourceUrl(vm.model.url);
      window.open(vm.model.reportDataURL);
    };

    vm.submitSearch = function (params) {
      getFlightMealDetails(params, function (flightMeal) {
        vm.model.searchPanelToggle = false;
        vm.model.mealData.mealSummary = flightMeal.mealDetailsSummaryDTOS;
        vm.model.mealData.mealDetails = flightMeal.mealDetailsDTOS;
      }, function (error) {
        vm.model.mealData.mealSummary = [];
        vm.model.mealData.mealDetails = [];
        MessageService.error(error);
      });
    };

    self.getSearchParamMap =  function() {
      vm.model.searchParamMap["flightNumber"] = vm.model.searchCriteria.flightNumber;
      vm.model.searchParamMap["flightDate"] = vm.model.searchCriteria.depatureDate;
      return vm.model.searchParamMap;
    };

    self.getFlightMealDetails = function (searchParam, successFn, errorFn) {

      var req = {};
      req.depatureDate = searchParam.depatureDate;
      req.flightNumber = searchParam.flightNumber;
      RemoteService.getMealDetails(req).then(
        function (response) {
          successFn(response.mealDetailResponses[0]);
        },
        function (error) {
          errorFn(error);
        });
    };
  };

}());
